import { useEffect, useState } from "react";
import { ActionIcon, Box, Group, UnstyledButton, useMantineColorScheme, useMantineTheme } from "@mantine/core";
import { Link, useLocation } from "@tanstack/react-router";
import { IconMoon, IconSun, IconUser } from "@tabler/icons-react";
import { useAuthLayout } from "../context";
import Logo from "./Logo";
import AuthButtons from "./AuthButtons";
import { AuthNav } from "./AuthNav";
import { LandingNav } from "./LandingNav";
import classes from "./Header.module.css";
import profileMenuClasses from "./ProfileMenu.module.css";

export default function Header() {
  const { navVariant, showProfileMenu, isAuthenticated } = useAuthLayout();
  const theme = useMantineTheme();
  const location = useLocation();
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Use mounted check to avoid hydration mismatch
  const isDark = mounted ? colorScheme === "dark" : false;


  return (
    <Group
      className={classes.root}
      justify="space-between"
      wrap="nowrap"
      p="sm"
    >
      {/* Logo on the left */}
      <Logo />

      {/* Navigation in the center (desktop only) */}
      <Box
        visibleFrom="md"
        style={{ flex: 1, display: "flex", justifyContent: "center" }}
      >
        {navVariant === "authed" && <AuthNav />}
        {navVariant === "landing" && <LandingNav />}
      </Box>

      {/* Right side - Theme toggle, Profile menu, or Auth buttons */}
      <Group gap="sm" wrap="nowrap">
        {/* Theme toggle for landing page */}
        {navVariant === "landing" && (
          <ActionIcon
            variant="subtle"
            color="gray"
            size="lg"
            onClick={toggleColorScheme}
            aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
            className={classes.themeToggle}
          >
            {isDark ? <IconSun size={20} /> : <IconMoon size={20} />}
          </ActionIcon>
        )}
        {showProfileMenu && (
          <UnstyledButton
            component={Link}
            to="/settings"
            className={profileMenuClasses.button}
            aria-label="Profile settings"
          >
            <IconUser size={24} color={theme.colors.primary[6]} stroke={1.5} />
          </UnstyledButton>
        )}
        {/* Show auth buttons for non-authenticated users */}
        {!isAuthenticated && <AuthButtons />}
      </Group>
    </Group>
  );
}
